import { render, staticRenderFns } from "./AppPassword.vue?vue&type=template&id=5c15a0e0&scoped=true"
import script from "./AppPassword.vue?vue&type=script&lang=js"
export * from "./AppPassword.vue?vue&type=script&lang=js"
import style0 from "./AppPassword.vue?vue&type=style&index=0&id=5c15a0e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c15a0e0",
  null
  
)

export default component.exports